'use es6';

import FormattedMessage from 'I18n/components/FormattedMessage';
import { Component } from 'react';
import PropTypes from 'prop-types';
import UIModal from 'UIComponents/dialog/UIModal';
import UIDialogHeader from 'UIComponents/dialog/UIDialogHeader';
import UIDialogBody from 'UIComponents/dialog/UIDialogBody';
import UIDialogFooter from 'UIComponents/dialog/UIDialogFooter';
import UIButton from 'UIComponents/button/UIButton';
import UIAlert from 'UIComponents/alert/UIAlert';
import H2 from 'UIComponents/elements/headings/H2';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default class ForceTemplateSwapModal extends Component {
  renderFlexColumnMessage() {
    const {
      hasModulesInFlexColumn
    } = this.props;
    if (hasModulesInFlexColumn) {
      return /*#__PURE__*/_jsxs("div", {
        children: [/*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(UIAlert, {
          type: 'warning',
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "templateMissing.columnWarning"
          })
        })]
      });
    }
    return null;
  }
  render() {
    const {
      onConfirm,
      messageKey,
      shouldShowRestore,
      onRestore
    } = this.props;
    return /*#__PURE__*/_jsxs(UIModal, {
      children: [/*#__PURE__*/_jsx(UIDialogHeader, {
        children: /*#__PURE__*/_jsx(H2, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: 'templateMissing.header'
          })
        })
      }), /*#__PURE__*/_jsxs(UIDialogBody, {
        children: [/*#__PURE__*/_jsx(FormattedMessage, {
          message: `templateMissing.${messageKey}`
        }), this.renderFlexColumnMessage()]
      }), /*#__PURE__*/_jsxs(UIDialogFooter, {
        children: [/*#__PURE__*/_jsx(UIButton, {
          use: "primary",
          onClick: onConfirm,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "templateMissing.button"
          })
        }), shouldShowRestore && /*#__PURE__*/_jsx(UIButton, {
          use: "secondary",
          onClick: onRestore,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "templateMissing.restore"
          })
        })]
      })]
    });
  }
}
ForceTemplateSwapModal.propTypes = {
  onConfirm: PropTypes.func.isRequired,
  messageKey: PropTypes.string.isRequired,
  hasModulesInFlexColumn: PropTypes.bool.isRequired,
  shouldShowRestore: PropTypes.bool.isRequired,
  onRestore: PropTypes.func.isRequired
};